import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  username: string;
  email: string;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  setTokens: (access: string, refresh: string) => void;
  setUser: (user: User) => void;
  login: (user: User, access: string, refresh: string) => void;
  logout: () => void;
  completeOnboarding: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      setTokens: (access: string, refresh: string) => 
        set({ accessToken: access, refreshToken: refresh }),
      setUser: (user: User) => 
        set({ user, isAuthenticated: true }),
      login: (user: User, access: string, refresh: string) => 
        set({ 
          user, 
          accessToken: access, 
          refreshToken: refresh, 
          isAuthenticated: true 
        }),
      logout: () => 
        set({ 
          user: null, 
          accessToken: null, 
          refreshToken: null, 
          isAuthenticated: false 
        }),
      completeOnboarding: () => 
        set((state) => ({
          user: state.user ? { ...state.user, onboarding_completed: true } : null
        })),
    }),
    {
      name: 'auth-storage',
      // Only persist tokens and authentication status, not user data
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
); 